import React from 'react'
import Title from '../layouts/Title'
import Reveal from '../layouts/Reveal';
import { projectsData } from "../../constants";
import ProjectsCard from './ProjectsCard';
import FeaturedProject from './FeaturedProject';

const Projects = () => {
  const featured = projectsData.filter((p) => p.featured);
  const others = projectsData.filter((p) => !p.featured);
  return (
    <section id="projects" className="sectionWrap">
      <Title title="Impact, Not Just Code" des="Selected Work" />
      <div className="flex flex-col gap-10">
        {featured.map((project) => (
          <Reveal key={project.title}>
            <FeaturedProject {...project} />
          </Reveal>
        ))}
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {others.map((project, index) => (
            <Reveal key={project.title} delay={index * 0.1}>
              <ProjectsCard {...project} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects
